import React from 'react';
import BulkUploadRequirementStepProgress from 'src/components/selfServeWorkflows/requirementsPortal/bulkUploadSteps/BulkExecutionStepProgress';

const BulkExecutionRequirementPortal = () => {
	return (
		<div>
			<BulkUploadRequirementStepProgress />
		</div>
	);
};

export default BulkExecutionRequirementPortal;